(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["un-engraving-fields"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('engraving-preview')) {
    customElements.define(
      'engraving-preview',
      class extends HTMLElement {
        connectedCallback() {
          this.toggle = this.querySelector('[data-engraving-toggle]');
          this.fields = this.querySelector('[data-engraving-fields]');
          this.input = this.querySelector('[data-engraving-input]');
          this.font = this.querySelector('[data-engraving-font]');
          this.preview = this.querySelector('[data-engraving-preview]');
          this.count = this.querySelector('[data-engraving-count]');

          this.toggle.addEventListener('change', () => this.setEnabled());
          this.input.addEventListener('input', () => this.updatePreview());
          this.font.addEventListener('change', () => this.updateFont());
          this.setEnabled();
          this.updateFont();
        }

        setEnabled() {
          const enabled = this.toggle.checked;
          this.fields.hidden = !enabled;
          this.input.disabled = !enabled;
          this.font.disabled = !enabled;
          this.input.required = enabled;
          if (enabled) {
            this.input.focus();
            this.updatePreview();
          } else {
            this.input.value = '';
            this.updatePreview();
          }
        }

        updatePreview() {
          const value = this.input.value.trim();
          this.preview.textContent = value || 'Your name';
          this.count.textContent = this.input.value.length;
          requestAnimationFrame(() => {
            this.preview.style.fontSize = '';
            const width = this.preview.clientWidth;
            const textWidth = this.preview.scrollWidth;
            if (width > 0 && textWidth > width) {
              const size = parseFloat(getComputedStyle(this.preview).fontSize);
              this.preview.style.fontSize = `${size * width / textWidth}px`;
            }
          });
        }

        updateFont() {
          const family = 'UN ' + this.font.value;
          this.preview.style.fontFamily = '"' + family + '"';
          this.updatePreview();
          if (document.fonts) {
            document.fonts.load('400 18px "' + family + '"', this.input.value || 'Your name')
              .then(() => this.updatePreview()).catch(() => this.updatePreview());
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
